module.exports = __webpack_public_path__ + "img/image_2_1.38e4ef49.png";